import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import { PropType, computed } from 'vue';
import {
  AdSize, Billboard, MediumRectangle,
} from '@/common/adSizes';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClouDNSAd',
  props: {
  sizes: {
    type: Array as PropType<Array<AdSize>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const availableSizes = [
  Billboard,
  MediumRectangle,
];

const size = computed(() => availableSizes.find((s) => props.sizes.includes(s)) ?? 'hidden');
const sizeClasses = computed(() => {
  switch (size.value) {
    case Billboard:
      return 'w-[970px] h-[250px]';
    case MediumRectangle:
      return 'w-[300px] h-[250px]';
    default:
      return 'hidden';
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(size) != 'hidden')
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "https://www.cloudns.net/ads/id/987/",
        rel: "sponsored noopener",
        class: _normalizeClass([_unref(sizeClasses), 'block relative overflow-hidden rounded-md shadow-md border border-black/10'])
      }, [
        _createElementVNode("img", {
          src: `/img/${_unref(size)[0].toString().split('').reverse().join('')}x${_unref(size)[1].toString().split('').reverse().join('')}.png`,
          alt: "ClouDNS - 50% off DDoS protected DNS",
          class: "w-full h-full object-cover object-center"
        }, null, 8, _hoisted_1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})